import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function VanparnicniIzvrsniPostupakPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Vanparnični i izvršni postupak" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Vanparnični i izvršni postupak</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Vanparnični i izvršni postupak
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>

              <h3>Cilj predmeta</h3>
              <p>
                Glavni ciljevi izučavanja predmeta: Upoznavanje sa pojmom bitnim
                obilježjima i institutima vanparničnog i izvršnog prava.
                Upoznavanje studenata sa opštim pravilima vanparničnog postupka
                i pojedinim vanparničnim postupcima kao i opštim pravilima
                izvršnog postupka i postupkom izvršenja i postupkom
                obezbjeđenja. Osposobljavanje za praktičan rad i primjenu
                stečenih znanja stvaranjem preduslova kompetentnosti budućih
                nosilaca pravosudnih funkcija u oblasti vanparnične i izvršne
                procedure.
              </p>

              <h3>Ishod predmeta</h3>
              <p>
                Po uspješnom okončanju nastavnih aktivnosti i obaveza očekuje se
                da će studenti biti u mogućnosti da valjano analiziraju i tumače
                pravne izvore i institute u oblasti građanskog vanparničnog i
                izvršnog prava. Povezivanjem teorijskog i praktičnog znanja i
                vještina studenti će moći da samostalno, kompetentno i
                profesionalno kritički primjenjuju znanje iz oblasti
                vanparničnog i izvršnog prava i postupka.
              </p>

              <h3>Sadržaj predmeta</h3>
              <p>
                Upoznavanje, dogovor o radu i slično Pojam, funkcija,
                karakteristike građanskog vanparničnog i izvršnog prava, Mjesto
                vanparnice, subjekti, načela i razvoj procesa/postupka, Sudske
                odluke, pravni ljekovi i pravosnažnost. Uređenje ličnih stanja,
                oduzimanje i vraćanje poslovne sposobnosti, Prisilni smještaj u
                psihijatrijsku ustanovu. Proglašenje nestalog lica za umrlo i
                dokazivanje smrti. Uređenje porodičnih odnosa: produženje i
                prestanak roditeljskog prava, Oduzimanje i vraćanje roditeljskog
                prava, Dozvola za zaključenje braka, Proglašenje djeteta za
                rođeno u braku, Raspravljanje zaostavštine, Određivanje naknade
                za ekspropisanu nepokretnost, Sastavljanje i ovjeravanje
                sadržine isprava, sudski depozit, Uređenje upravljanja i
                korišćenja zajedničke stvari, Dioba zajedničkih stvari ili
                imovine, Uređenje međa, Pojam i predmet izvršnog postupka,
                načela, vrste izvršenja, Klauzula izvršnosti, Pretpostavke
                izvršenja, Obustava, odlaganje, pravni lijekovi, Postupak
                obezbjeđenja.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja i vježbe, seminarski rad, kolokvijumi, završni ispit.
                Predavanja i vježbe praćena su odgovarajućim posebno izrađenim
                prezentacijama. Za sve pravne kategorije i institute koriste se
                primjeri iz poslovne, sudske i arbitražne prakse uz interaktivno
                učešće studenata.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 1V</td>
                    <td>
                      Pojam, funkcija, karakteristike građanskog vanparničnog i
                      izvršnog prava, Mjesto vanparnice, subjekti, načela i
                      razvoj procesa/postupka
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 1V</td>
                    <td>Sudske odluke, pravni ljekovi i pravosnažnost</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 1V</td>
                    <td>
                      Uređenje ličnih stanja, oduzimanje i vraćanje poslovne
                      sposobnosti, Prisilni smještaj u psihijatrijsku ustanovu
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 1V</td>
                    <td>
                      Proglašenje nestalog lica za umrlo i dokazivanje smrti
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 1V</td>
                    <td>
                      Uređenje porodičnih odnosa: produženje i prestanak
                      roditeljskog prava, Oduzimanje i vraćanje roditeljskog
                      prava
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>3P + 1V</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 1V</td>
                    <td>
                      Dozvola za zaključenje braka, Proglašenje djeteta za
                      rođeno u braku
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 1V</td>
                    <td>Raspravljanje zaostavštine</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 1V</td>
                    <td>Određivanje naknade za ekspropisanu nepokretnost</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 1V</td>
                    <td>
                      Uređenje upravljanja i korišćenja zajedničke stvari, Dioba
                      zajedničkih stvari ili imovine, Uređenje međa
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 1V</td>
                    <td>
                      Sastavljanje i ovjeravanje sadržine isprava, sudski
                      depozit
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>3P + 1V</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 1V</td>
                    <td>
                      Pojam i predmet izvršnog postupka, načela, vrste izvršenja
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 1V</td>
                    <td>Klauzula izvršnosti, Pretpostavke izvršenja</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 1V</td>
                    <td>
                      Obustava, odlaganje, pravni lijekovi, Postupak
                      obezbjeđenja
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4č / 3h</td>
                            <td>Ukupno: 80h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3č / 2.15h</td>
                            <td>Nastava + završni ispit: 60h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 6h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default VanparnicniIzvrsniPostupakPM;
